export default function Hero() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20dramatic%20entertainment%20gossip%20news%20backdrop%20with%20deep%20red%20and%20black%20gradient%2C%20abstract%20geometric%20patterns%2C%20cinematic%20atmosphere%20with%20soft%20glowing%20highlights%2C%20modern%20editorial%20background%20design%2C%20warm%20dramatic%20mood&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="黑料在线背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full mx-auto px-4 md:px-6 py-16 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/90 text-background-50 text-xs md:text-sm font-semibold tracking-wide mb-5">
              🔥 热门黑料持续更新中
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-black text-background-50 leading-tight mb-4">
              黑料在线
              <span className="block text-lg md:text-xl lg:text-2xl font-semibold text-background-50/80 mt-2">
                暴走黑料·黑料社 系列化吃瓜第一站
              </span>
            </h1>

            <p className="text-base md:text-lg text-background-50/70 font-heading italic mb-6">
              整理暴走黑料、黑料社等特色黑料系列，满足你的系列化吃瓜需求
            </p>

            <p className="text-sm md:text-base text-background-50/60 leading-relaxed mb-8 max-w-xl lg:max-w-none">
              黑料在线是国内领先的系列化黑料整理与观看平台。我们全天候追踪暴走黑料、黑料社等热门系列的最新内容，以独特的视角和完整的归档体系，为你带来一站式的暴走黑料在线观看与黑料社在线观看体验。无论是最新爆料还是经典回顾，这里都是吃瓜爱好者的必刷站点。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-black text-accent-400">200+</div>
                <div className="text-xs md:text-sm text-background-50/50 mt-1">系列专题</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-black text-accent-400">50万+</div>
                <div className="text-xs md:text-sm text-background-50/50 mt-1">日活用户</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-black text-accent-400">全天候</div>
                <div className="text-xs md:text-sm text-background-50/50 mt-1">实时更新</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                onClick={(e) => {
                  e.preventDefault();
                  handleClick('#media');
                }}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap text-center no-underline"
              >
                <i className="ri-play-circle-line mr-2"></i>立即观看
              </a>
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  handleClick('#index');
                }}
                className="w-full sm:w-auto px-8 py-3.5 border border-background-50/30 hover:border-background-50/60 text-background-50 font-medium text-sm rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap text-center no-underline"
              >
                <i className="ri-grid-line mr-2"></i>浏览专题合集
              </a>
            </div>
          </div>

          <div className="hidden lg:flex flex-1 justify-center">
            <div className="relative w-full max-w-md aspect-[4/5] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=stylized%20entertainment%20news%20collage%20with%20dramatic%20red%20and%20dark%20aesthetic%2C%20modern%20editorial%20design%20with%20headline%20visuals%2C%20abstract%20geometric%20overlays%2C%20cinematic%20composition%20with%20warm%20dramatic%20lighting%2C%20magazine%20cover%20quality&width=600&height=750&seq=hero-visual-01&orientation=portrait"
                alt="黑料在线主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <span className="inline-block px-3 py-1 bg-accent-500/90 text-background-50 text-xs font-semibold rounded-full">
                  系列化吃瓜平台
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}